import type { BuyBridgeProduct } from "@/lib/calculator/buy-bridge";

/**
 * Serializable payload resolved by the Suspense-quarantined `BuyBridgeLoader` server child
 * and streamed into the single interactive client instance via `BuyBridgeDataBridge` →
 * BuyBridgeDataContext. Hub pages populate the map; locked spoke pages only need the
 * single product. Keeping this data separate from calculator state prevents a delayed
 * Saleor response from remounting the form and discarding user input.
 */
export interface CalculatorBuyBridgeData {
	buyBridge: BuyBridgeProduct;
	buyBridgeMap?: Record<string, NonNullable<BuyBridgeProduct>>;
}

export function getActiveBuyBridge(data: CalculatorBuyBridgeData | null, calcSlug: string): BuyBridgeProduct {
	if (!data) return null;
	const product = data.buyBridgeMap ? (data.buyBridgeMap[calcSlug] ?? null) : data.buyBridge;
	return product?.calcSlug === calcSlug ? product : null;
}

export function getInStockBuyBridgeSlugs(
	data: CalculatorBuyBridgeData | null,
): ReadonlySet<string> | undefined {
	if (!data?.buyBridgeMap) return undefined;
	const slugs = new Set<string>();
	for (const [slug, product] of Object.entries(data.buyBridgeMap)) {
		if (product.inStock) slugs.add(slug);
	}
	return slugs;
}
